import {combineReducers} from '@reduxjs/toolkit';
import authReducer, {resetAuth} from './slices/authSlice';
import superAdminDashboardReducer from './slices/superAdminDashboardSlice';
import patientDashboardReducer from './slices/patientDashboardSlice';
import specialistDashboardReducer from './slices/specialistDashboardSlice';
import appSettingsReducer from './slices/appSettingSlice';
import chatReducer from './slices/chatSlice';
import patientAdminReducer from './slices/patientAdminSlice';
import hospitalAdminReducer from './slices/hospitalAdminSlice';
import supportAdminReducer from './slices/supportAdminSlice';
import specialistAdminReducer from './slices/specialistAdminSlice';
import financeAdminReducer from './slices/financeAdminSlice';
import notificationReducer from './slices/notificationSlice';

import {PRE_SIGNUP_FILES_KEY} from '@/constants/keys';

const appReducer = combineReducers({
  auth: authReducer,
  superAdminDashboard: superAdminDashboardReducer,
  patientDashboard: patientDashboardReducer,
  specialistDashboard: specialistDashboardReducer,
  appSettings: appSettingsReducer,
  chat: chatReducer,
  patientAdmin: patientAdminReducer,
  hospitalAdmin: hospitalAdminReducer,
  supportAdmin: supportAdminReducer,
  specialistAdmin: specialistAdminReducer,
  financeAdmin: financeAdminReducer,
  notifications: notificationReducer,
});

/**
 * Root Reducer: Clears Redux state and localStorage on logout
 * Preserves pre-signup files (email-tagged for security) for user convenience
 */
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === resetAuth.type) {
    state = undefined;

    // ignore the pre-signup files key, remove the rest of the keys
    const localStorageKeys = Object.keys(localStorage);
    for (const key of localStorageKeys) {
      if (key === PRE_SIGNUP_FILES_KEY) {
        continue;
      }
      localStorage.removeItem(key);
    }
  }
  return appReducer(state, action);
};

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
